// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"332":"3e56ef5cb6272d30be3b","442":"5a96e0c660a3f62c593e"}[chunkId] + ".chunk.js";
};